import Whitelist from '@/models/whitelist'

export default {
  whitelists: [],
  whitelist: new Whitelist().getObject(),
  currentWhitelistId: null,
  availabilityInfo: [],
  nextAvailablePage: 0,
  currentPage: 0,
  pageSize: 9,
  whitelistsLoaded: false
}
